import React from 'react'
import Updates from '../Updates/Updates'
import './Rightside.css'

const RightSide = () => {
  return (
    <div className="RightSide">
        <h3>Profiles</h3>
        <Updates/>
    </div>
    
  )
}

export default RightSide